// extracted by mini-css-extract-plugin
module.exports = {"container":"ImagePlayer_container__E0GEV","loading":"ImagePlayer_loading__I4WHc","imageContainer":"ImagePlayer_imageContainer__2X9T_"};